import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseGovernmentAllocationsProps<T> = {
  filters: {
    companyId: string
    branchId?: string
    startDate?: string
    endDate?: string
    search?: string
    showDescendants?: boolean
  }
  mapper?: (data: any) => T
}

export const useGovernmentAllocations = <T,>({
  filters: { companyId, branchId, startDate, endDate, search, showDescendants },
  mapper = Mapper.default<T>(),
}: UseGovernmentAllocationsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['governmentAllocations', companyId, branchId, startDate, endDate, search, showDescendants],
    queryFn: () => {
      return privateAxios.get(`/billing/government_allocations`, {
        params: {
          'q[company_id_eq]': companyId,
          'q[branch_id_eq]': branchId,
          'q[applicable_start_date_lteq]': startDate,
          'q[applicable_end_date_gteq]': endDate,
          'q[show_from_descendants]': showDescendants,
          search,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
